'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var index = require('../../providers/ClaimBuilder/index.js');
var SessionContext = require('../../providers/SessionContext.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');
var PackageSelectionProvider = require('./PackageSelectionProvider.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const PackageSelectionViewRoot = _ref => {
  let {
    children
  } = _ref;
  const {
    state: {
      claimType
    }
  } = index.useClaimBuilder();
  const titan = useTitanAnalytics["default"]();
  const logEvent = useAnalytics["default"]();
  const {
    orderNumber
  } = SessionContext.useSession();
  const {
    selectedShipments,
    eligibleShipments,
    ineligibleShipments
  } = PackageSelectionProvider.usePackageSelection();
  React.useEffect(() => {
    // Note: This effect is only called on first component render
    const shipmentsEligible = [...selectedShipments, ...eligibleShipments].map(shipment => {
      var _shipment$edd;
      return {
        status: shipment.status,
        statusCode: shipment.statusCode,
        tracking_number: shipment.trackingNumber,
        edd: (_shipment$edd = shipment.edd) === null || _shipment$edd === void 0 ? void 0 : _shipment$edd.begin,
        item_skus: shipment.items.map(item => item.sku)
      };
    });
    const shipmentsIneligible = ineligibleShipments.map(shipment => {
      var _shipment$edd2;
      return {
        status: shipment.status,
        statusCode: shipment.statusCode,
        tracking_number: shipment.trackingNumber,
        edd: (_shipment$edd2 = shipment.edd) === null || _shipment$edd2 === void 0 ? void 0 : _shipment$edd2.begin,
        item_skus: shipment.items.map(item => item.sku),
        ineligibility_reason: shipment.evaluatedEligibility.ineligibilityReason
      };
    });
    const batchEvent = {
      batch: [{
        type: 'page',
        name: 'Claim Package Selection'
      }, {
        event: 'products_list_viewed',
        type: 'track',
        properties: {
          list_id: 'package_selection',
          products: [...shipmentsEligible, ...shipmentsIneligible].map(shipment => ({
            product_id: shipment.tracking_number,
            sku: shipment.item_skus.join(','),
            brand: shipment.status,
            variant: shipment.statusCode,
            name: shipment.edd,
            category: shipment.ineligibility_reason
          }))
        }
      }]
    };
    if (selectedShipments.length) {
      batchEvent.batch.push({
        event: 'cart_viewed',
        type: 'track',
        properties: {
          list_id: 'package_selection',
          products: selectedShipments.map(shipment => {
            var _shipment$edd3;
            return {
              product_id: shipment.trackingNumber,
              sku: shipment.items.map(item => item.sku).join(','),
              brand: shipment.status,
              variant: shipment.statusCode,
              name: (_shipment$edd3 = shipment.edd) === null || _shipment$edd3 === void 0 ? void 0 : _shipment$edd3.begin,
              category: shipment.evaluatedEligibility.ineligibilityReason
            };
          })
        }
      });
    }
    titan === null || titan === void 0 ? void 0 : titan.batch(batchEvent)
    // eslint-disable-next-line no-console
    .catch(e => console.error(e));
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.PAGE_LOAD,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_SHIPMENT_SELECTION,
      page_step: useAnalytics.ClaimsPageStep.SELECTION,
      order_number: orderNumber,
      claim_reason: claimType,
      shipments_eligible: shipmentsEligible !== null && shipmentsEligible !== void 0 && shipmentsEligible.length ? shipmentsEligible : undefined,
      shipments_ineligible: shipmentsIneligible !== null && shipmentsIneligible !== void 0 && shipmentsIneligible.length ? shipmentsIneligible : undefined
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
const PackageSelectionViewRootGuarded = _ref2 => {
  let {
    children
  } = _ref2;
  const {
    state: {
      claimEligibilityInfo,
      packageClaims
    },
    handleInvalidData
  } = index.useClaimBuilder();
  if (!(claimEligibilityInfo !== null && claimEligibilityInfo !== void 0 && claimEligibilityInfo.shipments) || claimEligibilityInfo.shipments.filter(shipment => !shipment.eligibility).length > 0) {
    handleInvalidData();
    return null;
  }
  return /*#__PURE__*/React__default["default"].createElement(PackageSelectionProvider.PackageSelectionProvider, {
    value: {
      shipments: claimEligibilityInfo.shipments,
      packageClaims
    }
  }, /*#__PURE__*/React__default["default"].createElement(PackageSelectionViewRoot, null, children));
};

exports["default"] = PackageSelectionViewRootGuarded;
